export default __webpack_public_path__ + "static/media/Screenshot (6).44681e93.png";